// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"128":"ParrilladasPrueba","308":"Parrilladas","451":"Historia","630":"Pruebas2","686":"Contacto"}[chunkId] + "." + {"128":"e10175b6","308":"5bdba1bd","451":"1593382d","630":"8a35c912","686":"dc5b24a0"}[chunkId] + ".css";
};